export interface SpinnerProps {
    readonly testId?: string
}

export default function Spinner(props: SpinnerProps) {
    return <div data-testid={props.testId}>
        <p>Loading...</p>
    </div>
}
